import { render } from "./DeleteEventsView.vue?vue&type=template&id=25722106"
import script from "./DeleteEventsView.vue?vue&type=script&lang=js"
export * from "./DeleteEventsView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__